import "./styles.css";
import { ReactComponent as UsersIcon } from "../../../assets/svg/icons/users.svg";
import { ReactComponent as CalendarIcon } from "../../../assets/svg/icons/calendar.svg";
import { ReactComponent as PlusIcon } from "../../../assets/svg/icons/plus.svg";
import { ReactComponent as BackIcon } from "../../../assets/svg/icons/back.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/svg/icons/download.svg";
import { ViewCards } from "../../../components/ViewCards/Index";
import { useEditOnboarding } from "../../../hooks/useEditOnboarding";
import { CreateBatch } from "../../../components/EditOnboarding/CattleMap/CreateBatch/index";
import { CreateFarm } from "../../../components/EditOnboarding/PropertiesArea/Farm";
import { useEffect, useState } from "react";
import { useFilter } from "../../../hooks/useFilter";
import { MicroArea } from "../../../components/EditOnboarding/PropertiesArea/MicroArea";
import { Area } from "../../../components/EditOnboarding/PropertiesArea/Area";
import { Loading } from "../../../components/Loading/Index";
import { ViewTables } from "../../../components/ViewTables/Index";
import { CreateProducts } from "../../../components/Tasks/CreateProducts";
import { ButtonOnlyTitle } from "../../../components/Buttons/ButtonOnlyTitle/Index";
import CreateEvaluator from "../../../components/Tasks/CreateEvaluator/Modal/CreateEvaluator";
import { useTaskCreation } from "../../../hooks/useTaskCreation";
import { ListEvaluators } from "../../../components/Tasks/CreateEvaluator/ListEvaluators";
import StartEvaluation from "../../../components/Tasks/CreateEvaluator/Modal/StartEvaluation";
import axios from '../../../services/axios'
import { useNavigate } from "react-router-dom";
import Constants from "../../../constants/Index";
import { IOptionsSideBarLinks, IOptionsSystemManagerLinks, optionsSideBar } from "../../../contexts/FilterContext";
import CreatePastureManagement from "../../../components/Tasks/PastureManagement";
import ArchiveEvaluation from "../../../components/Tasks/CreateEvaluator/Modal/ArchiveEvaluation";
import CancelateEvaluation from "../../../components/Tasks/CreateEvaluator/Modal/CancelateEvaluation";
import { ViewInfo } from "../../../components/ViewInfos";
import { IOptionsEditOnboarding } from "../../../contexts/EditOnboardingContext";
import { Inventory } from "../../../components/Tasks/Inventory";
import { format } from "date-fns";
import { TableMonitorProvider } from "../../../contexts/TableMonitorContext";

export function ShowData() {
  const {
    filterSelected,
    setFilterSelected,
    idSelected,
    optionForm,
    setOptionForm,
    setFarmIdSelected
  } = useEditOnboarding();
  const navigate = useNavigate();
  const { systemManager, setSystemManager, sideBarOptionSelected, setModalCalendarFilter, setFocusLastDay, rangeDays, setSelectRangeDate } = useFilter();
  const { setModalCreateEvaluator, setModalStartEvaluator, modalStartEvaluator, allFarms } = useTaskCreation();

  useEffect(() => {
    if (allFarms)
      setFarmIdSelected(Number(allFarms[0].id))
  }, [allFarms]);

  const [titlePage] = useState(new Map());
  const [optionSelected, setOptionSelected] = useState<null | string>(null);

  const infos = ['PROFILES']
  const tables = ['PRODUCTS', 'TASK_EVALUATION', 'FAILURES_SYNC', 'PASTURE_EVALUATION']
  const forms = ['MANAGER_SYSTEM']
  const cards = ['PASTURE_MANAGEMENT', 'PROPERTIES_AREAS', 'CREATE_BATCH', 'CATTLE_MAP', 'INVENTORY']
  const formsAddExceptions: IOptionsEditOnboarding[] = ["animal-category", "weight-animals", "goals-birth", "goals-death"]
  const optionsWithoutAddButton = ['PASTURE_EVALUATION', 'TASK_EVALUATION', 'PROFILES', 'FAILURES_SYNC', 'INVENTORY']
  const optionsWithCalendar = ["TASK_EVALUATION", "INVENTORY"]

  useEffect(() => {
    titlePage.set("INVENTORY", "Realizar inventário");
    titlePage.set("TASK_EVALUATION", "Monitoramento de tarefas");
    titlePage.set("CREATE_PRODUCTS", "Cadastro de produto");
    titlePage.set("PRODUCTS", "Produtos");
    titlePage.set("PASTURE_EVALUATION", "Avaliação de pastagem");
    titlePage.set("MANAGER_EVALUATORS", "Gerenciar avaliadores");
    titlePage.set("PROPERTIES_AREAS", "Propriedades e Áreas");
    titlePage.set("PROFILES", "Perfis");
    titlePage.set("CREATE_BATCH", "Criação de Lotes");
    titlePage.set("CATTLE_MAP", "Categorias e Pesos");
    titlePage.set("PASTURE_MANAGEMENT", "Manejo de Pasto");
    titlePage.set("FAILURES_SYNC", "Falhas de sincronismo");
  }, []);

  useEffect(() => {
    if (systemManager == "PRODUCTS") setFilterSelected("create-products");
    if (systemManager == "PROPERTIES_AREAS") setFilterSelected("farms");
    if (systemManager == "CREATE_BATCH") setFilterSelected("batches");
    if (systemManager == "CATTLE_MAP") setFilterSelected("animal-category");
    if (systemManager == "PASTURE_MANAGEMENT") setFilterSelected("pasture-management");
    if (sideBarOptionSelected == "INVENTORY") setFilterSelected("batch-inventory")
    if (!forms.includes(sideBarOptionSelected)) setOptionForm(undefined)
  }, [sideBarOptionSelected]);

  useEffect(() => {
    if (sideBarOptionSelected == "MANAGER_SYSTEM") {
      setOptionSelected(systemManager)
    } else if (sideBarOptionSelected == "PASTURE_EVALUATION" && systemManager) {
      setOptionSelected(systemManager)
    } else {
      setOptionSelected(sideBarOptionSelected)
    }
  }, [systemManager, sideBarOptionSelected]);

  const [haveEvaluator, setHaveEvaluator] = useState(false);

  useEffect(() => {
    axios.get("users/user/evaluator")
      .then(({ data }) => {
        setHaveEvaluator(data.filter((el: any) => el.status == "ACTIVE").length > 0)
      })
  }, [, modalStartEvaluator, optionForm]);

  return (
    <>
      <div className="templateData">
        {/* Header */}
        <>
          <div className="container__category">
            <div className="d-flex flex-row">
              {
                optionSelected && !optionsSideBar.includes(optionSelected as IOptionsSideBarLinks) ?
                  <button
                    className={"back__button"}
                    onClick={() => {
                      if (optionSelected == 'MANAGER_EVALUATORS') {
                        setOptionSelected("PASTURE_EVALUATION")
                        setOptionForm(undefined)
                        setSystemManager(null)
                      } else {
                        optionForm ?
                          setOptionForm(undefined)
                          :
                          setSystemManager(null)
                      }
                    }}
                  >
                    <BackIcon />
                  </button>
                  : <></>
              }

              <h2>
                {titlePage.get(optionSelected)}
              </h2>
            </div>

            {filterSelected && !optionForm && !formsAddExceptions.includes(filterSelected) && optionSelected &&
              <>
                {
                  optionSelected === "PASTURE_EVALUATION" &&
                  <div style={{ display: "flex", gap: 10 }}>
                    <div style={{ width: 295 }}>
                      <ButtonOnlyTitle
                        title={"Iniciar avaliação"}
                        theme={"info"}
                        type="button"
                        onClick={() => setModalStartEvaluator(true)}
                        disabled={!haveEvaluator}
                      />
                    </div>
                    <button
                      className={"add__button"}
                      onClick={() => {
                        setModalCalendarFilter(true)
                        setFocusLastDay(false)
                      }}
                    >
                      <CalendarIcon />
                    </button>
                    <button
                      className={"add__button"}
                      onClick={() => {
                        setOptionSelected("MANAGER_EVALUATORS")
                        setOptionForm("create-evaluator")
                      }}
                    >
                      <UsersIcon />
                    </button>
                    <button
                      className={"add__button"}
                      onClick={() => {
                        navigate(Constants.EVALUATION_REPORT)
                      }}
                    >
                      <DownloadIcon />
                    </button>
                  </div>
                }

                {
                  optionsWithCalendar.includes(optionSelected) &&
                  <div style={{ display: "flex", gap: 10 }}>
                    <div className="dataFilter__owner--container" style={{ border: '1px solid #e5e5e5', cursor: "pointer" }} onClick={() => {
                      setSelectRangeDate(2)
                      setModalCalendarFilter(true)
                      setFocusLastDay(false)
                    }}>
                      <small>De</small>
                      <div>
                        <h6>{format(rangeDays?.from ? new Date(rangeDays.from) : new Date(), 'dd/MM/yyyy')}</h6>
                        <CalendarIcon />
                      </div>
                    </div>

                    <div className="dataFilter__owner--container" style={{ border: '1px solid #e5e5e5', cursor: "pointer" }} onClick={() => {
                      setSelectRangeDate(2)
                      setModalCalendarFilter(true)
                      if (rangeDays?.from?.toDateString() != rangeDays?.to?.toDateString()) {
                        setFocusLastDay(true)
                      }
                      else {
                        setFocusLastDay(false)
                      }
                    }}>
                      <small>Até</small>
                      <div>
                        <h6>{format(rangeDays?.to ? new Date(rangeDays.to) : new Date(), 'dd/MM/yyyy')}</h6>
                        <CalendarIcon />
                      </div>
                    </div>
                  </div>
                }

                {
                  !optionsWithoutAddButton.includes(optionSelected || "") &&
                  <button
                    className={"add__button"}
                    onClick={() => setOptionForm(filterSelected)}
                  >
                    <PlusIcon />
                  </button>
                }
              </>
            }

            {filterSelected && optionSelected == 'MANAGER_EVALUATORS' && !formsAddExceptions.includes(filterSelected) &&
              <button
                className={"add__button"}
                onClick={() => {
                  setOptionForm("create-evaluator")
                  setSystemManager("MANAGER_EVALUATORS")
                  setModalCreateEvaluator(true)
                }}
              >
                <PlusIcon />
              </button>
            }
          </div>
        </>
        {/* Header */}

        <div className="delimiter" style={{ marginBottom: 20 }} />

        {/* View */}
        {optionForm ?
          <section className={optionForm ? "body__editOnboarding" : ""}>
            {optionForm == "farms" ? <CreateFarm /> : <></>}
            {optionForm == "areas" ? <Area /> : <></>}
            {optionForm == "micro-areas" ? <MicroArea /> : <></>}
            {optionForm == "batches" ? <CreateBatch /> : <></>}
            {optionForm == "create-products" ? <CreateProducts /> : <></>}
            {optionForm == "create-evaluator" ? <ListEvaluators /> : <></>}
            {optionForm == "pasture-management" ? <CreatePastureManagement /> : <></>}
            {optionForm == "batch-inventory" ? <Inventory /> : <></>}
          </section>
          :
          optionSelected && (
            <>
              {tables.includes(optionSelected) && (
                <TableMonitorProvider>
                  <ViewTables />
                </TableMonitorProvider>
              )}
              {cards.includes(optionSelected) && <ViewCards />}
              {infos.includes(optionSelected) && <ViewInfo />}
            </>
          )
        }
        {/* View */}
      </div>

      {/* Modals */}
      {optionForm == "create-evaluator" && <CreateEvaluator /> }
      <StartEvaluation />
      <ArchiveEvaluation />
      <CancelateEvaluation />
      {/* Modals */}
    </>
  );
}
